import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';


@Injectable({
    providedIn: 'root'
})
export class TovpilLanguageService {

    private labels: Record<string, string> = {
        lbl_worked: "worked_",
        lbl_plw: "plw_",
        lbl_offering: "offering_",
        lbl_number: "number_",
        lbl_marriage_courses: "marriage_courses_",
        lbl_children: "children_",
        lbl_adolescents: "adolescents_",
        lbl_adults: "adults_",
        lbl_to: "to_",
        lbl_average_cost: "average_cost_",
        lbl_age: "age_",
        lbl_amount: "amount_",
        lbl_approve: "approve_",
        lbl_are_you_sure: "are_you_sure_",
        lbl_cell_phone: "cell_phone_",
        lbl_certificate: "certificate_",
        lbl_change_Status_Guide_or_Comment: "change_Status_Guide_or_Comment",
        lbl_church_name: "church_name_",
        lbl_comments: "comments_",
        lbl_confirm: "confirm_",
        lbl_coordination: "coordination_",
        lbl_coordination_catalog: "coordination_catalog_",
        lbl_coordinations: "coordinations_",
        lbl_coordinator: "coordinator_",
        lbl_current: "current_",
        lbl_current_list: "current_list_",
        lbl_date: "date_",
        lbl_delete_record: "delete_record_",
        lbl_description: "description_",
        lbl_edit: "edit_",
        lbl_email: "email_",
        lbl_exchange_rate: "exchange_rate_",
        lbl_future_guide: "future_guide_",
        lbl_gender: "gender_",
        lbl_go_Back: "back_",
        lbl_guide: "guide_",
        lbl_Guide: "Guide_",
        lbl_guide_id: "guide_id_",
        lbl_guideId: "guideId_",
        lbl_international_price_list: "international_price_list_",
        lbl_id: "id_",
        lbl_item: "item_",
        lbl_last_purchasing: "last_purchasing_",
        lbl_leaving_reason: "leaving_reason_",
        lbl_list: "list_",
        lbl_language: "language_",
        lbl_loading: "loading_",
        lbl_material_man: "material_man_",
        lbl_name: "name_",
        lbl_new: "new_",
        lbl_new_record: "new_record_",
        lbl_no_sent: "no_sent_",
        lbl_of: "of_",
        lbl_partic_partner: "partic_partners_",
        lbl_participants: "participants_",
        lbl_participants_12: "participants_",
        lbl_participants_1st: "participants_2nd_sesion_",
        lbl_particp15s: "10a15a_particip_",
        lbl_price: "price_",
        lbl_record: "record_",
        lbl_records: "records_",
        lbl_save: "save_",
        lbl_schedule: "schedule_",
        lbl_school_prep_guides: "school_prep_guides_",
        lbl_school_prep_guides_charge: "school_prep_guides_charge_",
        lbl_search: "search_",
        lbl_secretary: "secretary_",
        lbl_select: "select_",
        lbl_send: "send_",
        lbl_showing: "showing_",
        lbl_status: "status_",
        lbl_there_are: "there_are_",
        lbl_total: "total_",
        lbl_treasurer: "treasurer_",
        lbl_type: "type_",
        lbl_updated_data: "updated_data_",
        lbl_workshop: "workshop_",
        lbl_youngs: "youngs_",
        lbl_zonal_coordinations: "zonal_coordinations_",
        lbl_zone_price_list: "zone_price_list_",
        lbl_scope: "scope_",
        lbl_international_price: "internat_price_",
        lbl_zone: "zone_",
        lbl_natio_price: "natio_price_",
        lbl_public_price: "public_price_",
        lbl_price_list: "price_list_",
        lbl_login: "login_",
        lbl_then_try_it_again: "then_try_it_again_",
        lbl_translation: "translation_",
        lbl_local: "local_",
        lbl_national: "national_",
        lbl_guides_and_participants: "guides_and_participants_",
        lbl_country: "country_",
        lbl_currency: "currency_",
        lbl_yes: "yes_",
        lbl_no: "no_",
        lbl_starting_date: "starting_date_",
        lbl_area_code: "area_code_",
        lbl_zonal: "zonal_",
        lbl_record_not_valid: "record_not_valid_",
        lbl_entry_required_fields_and_pres: "entry_required_fields_and_pres",
        lbl_internal_server_error: "internal_server_error_",
        lbl_back: "back_",
        lbl_international: "international_",
        lbl_validate: "validate_",
        lbl_items_management_Int: "items_management_Int_",
        lbl_update: "update_",
        lbl_is_not_valid: "is_not_valid_",
        lbl_city: "city_",
        lbl_following_up: "following_up_",
        lbl_stage: "stage_",
        lbl_supervised: "supervised_",
        lbl_school: "school_",
        lbl_workshops_stages: "workshops_stages_",
        lbl_ending_date: "ending_date_",
        lbl_there_are_missing_values: "there_are_missing_values_",
        lbl_successfully_registered: "successfully_registered_",
        lbl_place_where_provide: "place_where_provide_",
        lbl_state: "state_",
        lbl_year: "year_",
        lbl_period: "period_",
        lbl_planning: "planning_",
        lbl_planned_date: "planned_date_",
        lbl_starting_time: "starting_time_",
        lbl_ending_time: "ending_time_",
        lbl_guide_mate_see_refunding_cases: "guide_mate_see_refunding_cases",
        lbl_place: "place_",
        lbl_guide_imparts: "guide_imparts_",
        lbl_change: "change_",
        lbl_sign_up: "sign_up_",
        lbl_will_be_removed: "will_be_removed_",
        lbl_service: "service_",
        lbl_no_records_found: "no_records_found_",
        lbl_pending: "pending_",
        lbl_history: "history_",
        lbl_available: "available_",
        lbl_commitment_letter: "commitment_letter_",
        lbl_signed: "signed_",
        lbl_not_provided: "not_provided_",
        lbl_personal_information: "personal_information_",
        lbl_last_name: "last_name_",
        lbl_issued_identity: "issued_identity_",
        lbl_job: "current_job_",
        lbl_marriage_status: "marriage_status_",
        lbl_birth_Date: "birth_Date_",
        lbl_home_phone: "home_phone_",
        lbl_address: "address_",
        lbl_county_city: "county_city_",
        lbl_neightborhood: "neightborhood_",
        lbl_street_and_number: "street_and_number_",
        lbl_zip_code: "zip_code_",
        lbl_sch_for_prepar_guid: "sch_for_prepar_guid_",
        lbl_user: "user_",
        lbl_previous_balance: "previous_balance_",
        lbl_die: "die_",
        lbl_payment: "payment_",
        lbl_coordination_guide_list: "coordination_guide_list_",
        lbl_select_guide: "select_guide_",
        lbl_registered_workshops_services: "registered_workshops_services_",
        lbl_session: "session_",
        lbl_check: "check_",
        lbl_and: "and_",
        lbl_accRec_Guides_Loc: "accRec_Guides_Loc_",
        lbl_material_payment: "material_payments_",
        lbl_short_Name: "short_Name_",
        lbl_churchs_chapels_parish: "churchs_chapels_parish_",
        lbl_vicarage: "vicarage_",
        lbl_deanery: "deanery_",
        lbl_day: "day_",
        lbl_hour: "hour_",
        lbl_document_id: "document_id_",
        lbl_orders_request: "orders_request_",
        lbl_new_output: "new_output_",
        lbl_receipts: "receipts_",
        lbl_delivery_date: "delivery_date_",
        lbl_set: "set_",
        lbl_sequence: "sequence_",
        lbl_set_price: "set_price_",
        lbl_show_all: "show_all_",
        lbl_group: "group_",
        lbl_entry: "entry_",
        lbl_quantity: "quantity_",
        lbl_inventory: "inventory_",
        lbl_material_payment_registry_Loc: "material_payment_registry_Loc_",
        lbl_workshops_registry_planing_loc: "workshops_registry_planing_loc",
        lbl_current_job: "current_job_",
        lbl_incidents: "incidents_",
        lbl_download: "download_",
        lbl_file: "file_",
        lbl_subject: "subject_",
        lbl_assigned: "assigned_",
        lbl_function: "function_",
        lbl_summary: "summary_",
        lbl_severity: "severity_",
        lbl_priority: "priority_",
        lbl_attach_file: "attach_file_",
        lbl_wish_to_continue: "wish_to_continue_",
        lbl_bad_request: "bad_request_",
        lbl_or: "or_",
        lbl_application: "application_",
        lbl_detail: "detail_",
        lbl_close: "close_",
        lbl_assign: "assign_",
        lbl_release: "release_",
        lbl_mark: "mark_",
        lbl_re_open: "re_open_",
        lbl_solution: "solution_",
        lbl_solved: "solved_",
        lbl_by: "by_",
        lbl_volunteer: "volunteer_",
        lbl_expert: "expert_",
        lbl_manager: "manager_",
        lbl_is_requiered: "is_requiered_",
        lbl_2ndSes: "_2ndSes_",
        lbl_1stSes: "_1stSes_",
        lbl_1stReu: "_1stReu_",
        lbl_FI_offer_statistics: "FI_offer_statistics_",
        lbl_abrTall: "abrTall_",
        lbl_vendor: "vendor_",
        lbl_OR_vendor_quote: "OR_vendor_quote_",
        lbl_req_Date: "req_Date_",
        lbl_no_envelopes: "no_envelopes_",
        lbl_record_already_exists: "record_already_exists_",
        lbl_brief_description_circumstance: "brief_description_circumstance",
        lbl_item_detail: "item_detail_",
        lbl_accept: "accept_",
        lbl_recover_record: "recover_record_",
        lbl_discard: "discard_",
        lbl_duplicated: "duplicated_",
        lbl_reports: "reports_",
        lbl_guides: "guides_",
        lbl_materials: "materials_",
        lbl_special_processes: "special_processes_",
        lbl_expenses_management: "expenses_management_",
        lbl_catalogs_management: "catalogs_management_",
        lbl_downloads: "downloads_",
        lbl_sent: "sent_",
        lbl_workshops_management: "workshops_management_",
        lbl_done: "done_",
        lbl_services: "services_",
        lbl_marr_cours: "marr_cours_",
        lbl_stages: "stages_",
        lbl_entry_physical_inventory: "entry_physical_inventory_",
        lbl_prayer_life_circle: "prayer_life_circle_",
        lbl_communion_service_group: "communion_service_group_",
        lbl_circle_guides: "circle_guides_",
        lbl_event_attendance_registration: "event_attendance_registration_",
        lbl_inventory_other_assets: "inventory_other_assets_",
        lbl_account_receiva_payable: "account_receiva_payable_",
        lbl_FI_offer_registry_Loc: "FI_offer_registry_Loc_",
        lbl_suppliers_requests: "suppliers_requests_",
        lbl_transfers_amoung_stores: "transfers_amoung_stores_",
        lbl_item_summary: "item_summary_",
        lbl_remission_search_history_costs: "remission_search_history_costs",
        lbl_FIII_Inventory_Balance_E_S: "FIII_Inventory_Balance_E_S_",
        lbl_registry_phisic_inventory_Loc: "registry_phisic_inventory_Loc_",
        lbl_registryApprove_phisic_inv_Nac: "registryApprove_phisic_inv_Nac",
        lbl_registryApprove_phisic_inv_Zon: "registryApprove_phisic_inv_Zon",
        lbl_registryApprove_phisic_inv_Int: "registryApprove_phisic_inv_Int",
        lbl_reg_invent_adjust_damaged_err: "reg_invent_adjust_damaged_err_",
        lbl_inventory_adjustments_approval: "inventory_adjustments_approval",
        lbl_expenses: "expenses_",
        lbl_expenses_by_period: "expenses_by_period_",
        lbl_income_expense_concepts: "income_expense_concepts_",
        lbl_items_zone: "items_zone_",
        lbl_citys_states: "citys_states_",
        lbl_users: "users_",
        lbl_local_coordination: "local_coordination_",
        lbl_international_team: "international_team_",
        lbl_cost_center: "cost_center_",
        lbl_concept: "concept_",
        lbl_play_audio: "play_audio_",
        lbl_manuals_tutorials: "manuals_tutorials_",
        lbl_secretary_formats: "secretary_formats_",
        lbl_treasurer_formats: "treasurer_formats_",
        lbl_searching_services: "searching_services_",
        lbl_weeknum_dayguide: "weeknum_dayguide_",
        lbl_weekday_dayguide: "weekday_dayguide_",
        lbl_main_address: "main_address_",
        lbl_store: "store_",
        lbl_zonal_teams: "zonal_teams_",
        lbl_role: "role_",
        lbl_aux_members: "aux_members_",
        lbl_national_coordination: "national_coordination_",
        lbl_local_teams: "local_teams_",
        lbl_national_teams: "national_teams_",
        lbl_superior_coordination: "superior_coordination_",
        lbl_others: "others_",
        lbl_any_zone_team_experience: "any_zone_team_experience_",
        lbl_any_natio_team_experience: "any_natio_team_experience_",
        lbl_sent_year: "sent_year_",
        lbl_zonal_coordination: "zonal_coordination_",
        lbl_nationality: "nationality_",
        lbl_birth_day: "birth_day_",
        lbl_birth_month: "birth_month_",
        lbl_birth_year: "birth_year_",
        lbl_level: "level_",
        lbl_workshopId: "workshop_id_",
        lbl_unit_price: "unit_price_",
        lbl_resource_not_found: "resource_not_found_",
        lbl_reload: "reload_",
        lbl_try: "try_",
        lbl_again: "again_",
        lbl_process: "process_",
        lbl_information: "information_",
        lbl_empty: "empty_",
        lbl_cancelled: "cancelled",
        lbl_insert: "insert_",
        lbl_valid: "valid_",
        lbl_value: "value_",
        lbl_later: "later_",
        lbl_additional: "additional_",
        lbl_is_not_allowed: "is_not_allowed_",
        lbl_for: "for_",
        lbl_entry_open_orders: "entry_open_orders_",
        lbl_lower_than: "lower_than_",
        lbl_must: "must_",
        lbl_be: "be_",
        lbl_equals_to: "equals_to_",
        lbl_without: "without_",
        lbl_create: "create_",
        lbl_unable: "unable_",
        lbl_package: "package_",
        lbl_deleted: "deleted_",
        lbl_only: "only_",
        lbl_period_amount: "period_amount_",
        lbl_period_die_payment: "period_die_payment_",
        lbl_pending_amount: "pending_amount_",
        lbl_zip: "zip_",
        lbl_registered_workshops: "registered_workshops_",
        lbl_individual: "individual_",
        lbl_intervener: "intervener_",
        lbl_material: "material_",
        lbl_served: "served_",
        lbl_cxc: "cxc_",
        lbl_balances: "balances_",
        lbl_delivery: "delivery_",
        lbl_new_return: "new_return_",
        lbl_received: "received_",
        lbl_closed: "closed_",
        lbl_items: "items_",
        lbl_unit_suffix: "unit_suffix_",
        lbl_associated: "associated_",
        lbl_collection: "collection_",
        lbl_link: "link_",
        lbl_show: "show_",
        lbl_greater_than: "greater_than_",
        lbl_individuals: "individuals_",
        lbl_all: "all_",
        lbl_amounts: "amounts_",
        lbl_in: "in_",
        lbl_negatives: "negatives_",
        lbl_is_going_to_apply: "is_going_to_apply_",
        lbl_rule: "rule_",
        lbl_addition: "addition_",
        lbl_save_order: "save_order_",
        lbl_order: "order_",
        lbl_orders: "orders_",
        lbl_sent_date: "sent_Date_",
        lbl_receiving_date: "receiving_date_",
        lbl_separated: "separated_",
        lbl_requested: "requested_",
        lbl_required: "required_",
        lbl_applicant: "applicant_",
        lbl_approved: "approved_",
        lbl_actions: "actions_",
        lbl_export_to_excell: "export_to_excell_",
        lbl_export_to_pdf: "export_to_PDF_",
        lbl_requests: "requests_",
        lbl_items_requested: "items_requested_",
        lbl_requested_id: "requested_id_",
        lbl_item_id: "item_id_",
        lbl_opened_request: "opened_request_",
        lbl_closed_request: "closed_request_",
        lbl_request_date: "request_date_",
        lbl_out_of_stock: "out_of_stock_",
        lbl_output: "output_",
        lbl_return: "return_",
        lbl_duration: "duration_",
        lbl_length: "length_",
        lbl_play: "play_",
        lbl_stop: "stop_",
        lbl_exit: "exit_",
        lbl_region: "region_",
        lbl_invCtl_YN: "invCtl_YN_",
        lbl_creating: "creating_",
        lbl_not_found: "not_found_",
        lbl_updating: "updating_",
        lbl_deleting: "deleting_",
        lbl_please: "please_",
        lbl_institutional: "institutional_",
        lbl_continue: "continue_",
        lbl_blocked: "blocked_",
        lbl_items_guides: "items_guides_",
        lbl_error: "error_",
        lbl_there_is_not: "there_is_not_",
        lbl_params: "params_",
        lbl_acquisition: "acquisition_",
        lbl_rights: "rights_",
        lbl_language_: "language_",
        lbl_category_: "category_",
        lbl_description_: "description_",
        lbl_author_: "author_",
        lbl_format_: "format_",
        lbl_duration_: "duration_",
        lbl_options_: "options_",
        lbl_img_picture_: "img_picture_",
        lbl_path_: "path_",
        lbl_name_: "name_",
        lbl_grant: "grant_",
        lbl_order_date: "order_date_",
        lbl_transfer: "transfer_",
        lbl_destination: "destination_",
        lbl_give_back_: "give_back_",
        lbl_manual_number: "manual_number_",
        lbl_created_date: "created_date_",
        lbl_destiny_coordination: "destiny_coordin_",
        lbl_origin: "origin_",
        lbl_church: "church_",
        lbl_returning_date: "returning_date_",
        lbl_add: "add_",
        lbl_movement: "movement_",
        lbl_storeId: "storeId_",
        lbl_key: "key_",
        lbl_administration: "administration_",
        lbl_documents: "documents_",
        lbl_properties: "properties_",
        lbl_non_existent: "non_existent_",
        lbl_videos: "videos_",
        lbl_upload: "upload_",
        lbl_options: "options_",
        lbl_extern: "extern_",
        lbl_system_id: "system_id_",
        lbl_guide_name: "guide_name_",
        lbl_mobile_phone: "mobile_phone_",
        lbl_other_phone: "other_phone_",
        lbl_status_guide: "status_guide_",
        lbl_guide_type: "guide_type_",
        lbl_male_female: "male_female_",
        lbl_spoken_language: "spoken_language_",
        lbl_resident_country: "resident_country_",
        lbl_local_country: "local_country_",
        lbl_local_state: "local_state_",
        lbl_local_city: "local_city_",
        lbl_country_address: "country_address_",
        lbl_state_address: "state_address_",
        lbl_city_address: "city_address_",
        lbl_current_role: "current_role_",
        lbl_current_level: "current_level_",
        lbl_zone_experience: "zone_experience_",
        lbl_natio_experience: "natio_experience_",
        lbl_sending_year: "sending_year_",
        lbl_sending_month: "sending_month_",
        lbl_sending_day: "sending_day_",
        lbl_general: "general_",
        lbl_personal: "personal_",
        lbl_experience: "experience_",
        lbl_consult: "consult_",
        lbl_audios: "audios_",
        lbl_uri: "uri_",
        lbl_width: "width_",
        lbl_height: "height_",
        lbl_video_picture: "video_picture_",
        lbl_player_embed_url: "player_embed_url_",
        lbl_download_cdn_video_360: "download_cdn_video_360_",
        lbl_download_cdn_video_720: "download_cdn_video_720_",
        lbl_path: "path_",
        lbl_current_balance : "current_balance_",
        lbl_month : "month_",
        lbl_semester: "semester_",
        lbl_receivable_accounting: "receivable_accounting_",
        lbl_payable_accounting: "payable_accounting_",
        lbl_economic_reality : "economic_reality_"
    }

    constructor(private apiService: ApiService) { }

    getTranslatedLabels(_language, _region): Promise<void> {
        const labelIds = Object.keys(this.labels);
        const lstLabels = labelIds.map((labelId) => this.labels[labelId]);

        return this.apiService
            .listByLanguageMultFields({
                language: _language,
                region: _region,
                lstLabels: lstLabels,
            })
            .then((trDocs) => {
                const labelTranslations: Record<string, string> = {};
                trDocs.forEach((element) => {
                    labelTranslations[element.labelId] = element.translation;
                });

                labelIds.forEach((labelId) => {
                    this.labels[labelId] = labelTranslations[this.labels[labelId]];
                });
            });
    }

    getLabels(): Record<string, string> {
        return { ...this.labels };
    }

    getLabel(labelId: string): string {
        return this.labels[labelId] || labelId;
    }

    translateCols(cols) {
        cols.forEach(item => {
            item.name = this.labels[item.name];
        });
        return cols;
    }
}

